import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// const InputElement = styled.input`
//     border: 0!important;
//     border-radius: 4px!important;
//     padding: 12px 16px!important;
//     margin: 8px 8px!important;
//     outline: none;
//     background-color: #f5f5f5;
//     ::placeholder {
//         color: #999;
//     }
// `;

const Container = styled.div`
    cursor: pointer;
    font-size: 12px;
    margin-left: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    width: 90px;
    max-width: 90px;

    img {
        display: inline-block;
        width: 35px;
        margin: 0;
    }
`;

const CheckboxPublicPrivate = ({ defaultValue, ...props }) => {
    const [checked, setChecked] = useState(props.defaultChecked === "on" || props.defaultChecked === true);

    const { i18n } = useTranslation('common');

    React.useEffect(() => {
        setChecked(props.defaultChecked === "on" || props.defaultChecked === true);
    }, [props.defaultChecked]);
    const onClick = (event) => {
        setChecked(!checked);
    };

    return (
        <Container onClick={onClick}>
            {checked ? (i18n.language === 'fr' ? 'Public' : 'Public') : (i18n.language === 'fr' ? 'Privé' : 'Private')}
            {checked ? <img src='/img/toggle_on.png' alt='' /> : <img src='/img/toggle_off.png' alt='' />}
            <input type='checkbox' hidden readOnly name={props.name} checked={checked} />
        </Container>
    );
};

export default CheckboxPublicPrivate;
